<template> 
  <div>
  <h3>Produtos Cadastrados <span class="label label-warning">{{ this.status(filial) }}</span></h3>
    <table class="table table-striped table-bordered">
          <thead> 
            <tr>  
              <td>Id</td> 
              <td>Produto</td>
              <td>Quantidade Por Pessoa </td>  
              <td>Quantidade Em Estoque</td>  
              <td></td>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(produto, indice) of produtos"> 
              <td>{{ produto.Id }}</td>
              <td><input type="text" min="0" class="form-control" v-model="produto.Nome" /></td>
              <td><input type="number" min="0" class="form-control" v-model="produto.QuantidadePorPessoa" /></td>
              <td> <input type="number" min="0" class="form-control" v-model="produto.QuantidadeEmEstoque" /> </td>
              <td><button type="button" class="btn btn-primary" title="Atualizar" @click="atualizar(indice)" > <i class="fa fa-save" aria-hidden="true"></i> </button>
                <button type="button" class="btn btn-danger" title="Excluir Produto" @click="deletar( produto.Id )" > <i class="fa fa-remove" aria-hidden="true"></i> </button>   </td>
            </tr>
            <tr v-if="produtos.length == 0">
              <td colspan="5">Não encontramos nenhum produto cadastro nessa Unidade</td>
            </tr>
          </tbody>
          <tfoot> 
            <tr>
              <td colspan="5" class="text-right">
                <button type="button" class="btn btn-success" title="Incluir Produto"  data-toggle="modal" data-target="#modalIncluirProduto" > <i class="fa fa-plus" aria-hidden="true"></i> </button> 
              </td>
            </tr>
          </tfoot>
        </table> 
        <IncluirProduto /> 
  </div> 
</template>
<script>
import IncluirProduto from './IncluirProduto.vue'
export default {
  created: function () {
    this.filial = parseInt(localStorage.getItem('Unidade'))
    this.listar()
  },
  methods: {
    listar () {
      this.$http.get('estoque/listar?unidade=' + parseInt(localStorage.getItem('Unidade')))
        .then(function (res) {
          this.produtos = res.body
        })
    },
    status (id) {
      let escrito = ''
      switch (id) {
        case 0:
          escrito = 'Matriz'
          break
        case 1:
          escrito = 'ABC'
          break
        case 2:
          escrito = 'Alphaville'
          break
        case 4:
          escrito = 'Campinas'
          break
        case 5:
          escrito = 'Curitiba'
          break
        case 6:
          escrito = 'Faria Lima'
          break
        case 7:
          escrito = 'Guarulhos'
          break
        case 8:
          escrito = 'Jundiaí'
          break
        case 10:
          escrito = 'Rio de Janeiro'
          break
        case 11:
          escrito = 'Santo Amaro'
          break
        case 14:
          escrito = 'Recife'
          break
      }
      return escrito
    },
    atualizar (indice) {
      let view = this.produtos[indice]
      this.$http.post('estoque/atualizar', view)
        .then(function (res) {
          alert('Produto atualizado com sucesso')
        })
    },
    deletar (id) {
      this.$http.delete('estoque/deletar?id=' + id)
        .then(function (res) {
          alert('Produto excluído com sucesso')
          location.reload()
        })
    }
  },
  components: {
    IncluirProduto
  },
  data () {
    return {
      produtos: [],
      filial: ''
    }
  }
}
</script>
<style>

</style>



// WEBPACK FOOTER //
// ProdutosCadastrados.vue?66891a8e